<template>
  <div
    v-if="calculators && !isLoading"
    class="calculators__container"
  >
    <div
      v-for="calculator of calculators"
      :key="calculator.folderGuid"
    >
      <calculator-card
        :calculator="calculator"
        @on-calculate="onCalculate"
        @on-delete="onDelete"
        @on-edit="onEdit"
      />
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import CalculatorCard from '@/modules/LoanCalculator/components/CalculatorCard.vue';

const {mapState} = createNamespacedHelpers('sidebar');
const {mapActions: dataManagementMapActions} = createNamespacedHelpers('dataManagement');
const {
  mapState: loanCalculatorMapState,
  mapActions: loanCalculatorActions,
} = createNamespacedHelpers('loanCalculator');
export default {
  name: 'CalculatorsList',
  components: {CalculatorCard},
  props: ['items'],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...loanCalculatorMapState({
      calculators: state => state.data,
    }),
  },
  methods: {
    ...dataManagementMapActions([
      'getModuleData',
    ]),
    ...loanCalculatorActions([
      'getAllCalculator',
      'deleteCalculator',
      'showAddEditModal',
      'calculate',
    ]),
    async onDelete(calculator) {
      const confirm = await this.$confirm(
        'Deleting Calculator...',
        'You are deleting calculator. This will delete all tables created by the system for this configuration. Are you sure you want to continue?',
      );

      if (confirm) {
        const {success, body} = await this.deleteCalculator(calculator.loanCalculatorId);
        if (success) {
          this.$toasted.success('Calculator deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    onEdit(calculator) {
      this.showAddEditModal(calculator);
    },
    async onCalculate(calculator) {
      this.isLoading = true;
      const {success, body} = await this.calculate(calculator.loanCalculatorId);
      if (success) {
        await this.getModuleData(this.moduleUuid);
        // await this.prepareData();
        this.$toasted.success(
          `Entity with name ${calculator.loanCalculatorName} calculated successfully`, {
            duration: TOASTER_DURATION,
          });
      } else {
        this.$toasted.error(body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
      this.isLoading = false;
    },
  },
  async mounted() {
    this.moduleUuid = this.$route.query.module_uuid;
  },
};
</script>

<style scoped lang="scss">
.calculators__container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1rem;
}
</style>